// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid #f0f0f0;
}

/* Announcement Bar */
.announcement-bar {
  background: #2d2d2d;
  color: white;
  overflow: hidden;
  position: relative;
  height: 38px;
}

.announcement-content {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.announcement-text {
  display: flex;
  align-items: center;
  gap: 50px;
  white-space: nowrap;
  animation: scroll-left 30s linear infinite;
  padding: 10px 0;
}

.announcement-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  font-weight: 500;
  padding: 0 20px;
}

.announcement-item .icon {
  font-size: 1rem;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.announcement-bar:hover .announcement-text {
  animation-play-state: paused;
}

/* Top Info Bar */
.top-info-bar {
  background: #f8f8f8;
  padding: 8px 0;
  border-bottom: 1px solid #e0e0e0;
}

.social-icons {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  gap: 15px;
  justify-content: flex-start;
}

.social-icons a {
  font-size: 1.2rem;
  color: #666;
  transition: color 0.3s ease;
  text-decoration: none;
}

.social-icons a:hover {
  color: inherit;
}

/* Top Bar */
.top-bar {
  background: none;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 50px;
  font-size: 0.85rem;
}

.social-links {
  display: flex;
  gap: 15px;
}

.social-links a {
  color: white;
  text-decoration: none;
  font-size: 0.9rem;
  transition: opacity 0.3s ease;
}

.social-links a:hover {
  opacity: 0.8;
}

.auth-buttons {
  display: flex;
  gap: 15px;
}

.btn-register,
.btn-login {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: white;
  padding: 6px 18px;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.8rem;
  letter-spacing: 0.5px;
}

.btn-register:hover,
.btn-login:hover {
  background: white;
  color: inherit;
  border-color: white;
}

/* Main Navigation */
.main-nav {
  background: white;
  border-bottom: 1px solid #b5b5b5;
}

.nav-container {
  max-width: 1728px;
  margin: 0 auto;
  padding: 16px 160px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
}

.logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.logo:hover {
  transform: scale(1.05);
}

.logo-image {
  height: 34px;
  width: auto;
  object-fit: contain;
  display: block;
}

/* Search field */
.search-field {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
  height: 24px;
  width: 372px;
  flex-shrink: 0;
}

.search-field-icon {
  width: 24px;
  height: 24px;
  opacity: 0.6;
}

.search-field-placeholder {
  font-size: 14px;
  font-weight: 500;
  color: #656565;
  opacity: 0.5;
}

.search-wrap {
  position: relative;
  flex-shrink: 0;
}

.search-field-input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  color: #2e2e2e;
  font-family: inherit;
}

.search-field-input::placeholder {
  color: #656565;
  opacity: 0.5;
}

.search-dropdown {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  max-height: 340px;
  overflow-y: auto;
  z-index: 1000;
}

.search-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  cursor: pointer;
}

.search-row:hover {
  background: #f5f5f5;
}

.search-row-img {
  width: 36px;
  height: 36px;
  border-radius: 4px;
  object-fit: cover;
  background: #f0f0f0;
  flex-shrink: 0;
}

.search-row-name {
  flex: 1 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 500;
  color: #2e2e2e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.search-row-price {
  font-size: 13px;
  font-weight: 600;
  color: #2e2e2e;
  flex-shrink: 0;
}

.search-empty {
  padding: 12px;
  font-size: 13px;
  color: #656565;
}

/* Nav links */
.main-nav-links {
  display: flex;
  align-items: center;
  gap: 52px;
  flex-shrink: 0;
}

.main-nav-link {
  font-size: 16px;
  font-weight: 500;
  color: #000;
  text-decoration: none;
  white-space: nowrap;
  opacity: 0.3;
}

.main-nav-link.active {
  opacity: 1;
}

.main-nav-link.disabled {
  cursor: default;
}

.logo-icon {
  font-size: 2rem;
}

.logo-text {
  font-size: 1.8rem;
  font-weight: 900;
  background: none;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 1px;
}

.nav-menu {
  display: flex;
  gap: 35px;
  align-items: center;
}

.nav-link {
  color: #2d3748;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
  position: relative;
  padding: 5px 0;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: none;
  transition: width 0.3s ease;
}

.nav-link:hover::after,
.nav-link.active::after {
  width: 100%;
}

.nav-link:hover,
.nav-link.active {
  color: inherit;
}

.nav-actions {
  display: flex;
  gap: 24px;
  align-items: center;
  flex-shrink: 0;
}

/* Burger Button - Hidden on Desktop */
.burger-btn {
  display: none;
  background: transparent;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: #333;
  padding: 8px;
  transition: all 0.3s ease;
}

.burger-btn:hover {
  color: #667eea;
}

.icon-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-btn img {
  width: 32px;
  height: 32px;
  display: block;
}

.icon-btn:hover {
  transform: scale(1.1);
}

.search-btn, .user-btn {
  font-size: 1.4rem;
}

.admin-btn {
  background: none;
  color: white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(255, 140, 0, 0.3);
}

.admin-btn:hover {
  color: white;
  box-shadow: 0 4px 12px rgba(255, 140, 0, 0.5);
  transform: translateY(-2px) rotate(90deg);
}

.cart-btn {
  position: relative;
}

.cart-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  background: #2d3748;
  color: white;
  font-size: 0.65rem;
  font-weight: 700;
  padding: 2px 5px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
}

/* Categories Bar */
.categories-bar {
  background: #fafafa;
  border-top: 1px solid #e8e8e8;
  border-bottom: 1px solid #e8e8e8;
}

.categories-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  gap: 40px;
  justify-content: center;
  align-items: center;
  min-height: 50px;
}

.category-link {
  color: #333;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  padding: 15px 0;
  position: relative;
  transition: color 0.3s ease;
  white-space: nowrap;
}

.category-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: #ed2b91;
  transition: width 0.3s ease;
}

.category-link:hover {
  color: #ed2b91;
}

.category-link:hover::after {
  width: 100%;
}

.menu-toggle {
  display: none;
  background: transparent;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: #2d3748;
}

@media (max-width: 1400px) {
  .nav-container {
    padding: 16px 48px;
  }

  .search-field {
    width: 260px;
  }

  .main-nav-links {
    gap: 28px;
  }
}

@media (max-width: 1024px) {
  .nav-menu {
    gap: 20px;
  }

  .nav-link {
    font-size: 0.9rem;
  }

  .nav-container > .search-wrap,
  .main-nav-links {
    display: none;
  }

  .burger-btn {
    display: block;
  }

  .nav-container {
    padding: 16px 24px;
  }
}

.mobile-nav-panel {
  display: none;
}

@media (max-width: 1024px) {
  .main-nav {
    position: relative;
  }

  .mobile-nav-panel {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 24px 24px;
    border-top: 1px solid #f0f0f0;
    background: white;
  }

  .mobile-search-field {
    width: 100%;
  }

  .mobile-search-field .search-field {
    width: 100%;
    box-sizing: border-box;
  }

  .mobile-nav-link {
    font-size: 16px;
    font-weight: 500;
    color: #2e2e2e;
  }
}

@media (max-width: 768px) {
  .announcement-bar {
    height: 36px;
  }

  .announcement-item {
    font-size: 0.8rem;
    padding: 0 15px;
  }

  .announcement-text {
    gap: 30px;
  }

  .top-info-bar {
    padding: 5px 0;
  }

  .social-icons {
    padding: 0 20px;
    gap: 12px;
  }

  .social-icons a {
    font-size: 1rem;
  }
  
  .nav-container {
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /* Logo on the left */
  .logo {
    justify-self: start;
  }
  
  .logo-image {
    height: 50px;
  }

  /* Cart on the right */
  .nav-actions {
    gap: 15px;
    justify-self: end;
  }

  .icon-btn {
    font-size: 1.3rem;
    padding: 5px;
  }
  
  .categories-bar {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .categories-container {
    padding: 0 20px;
    gap: 25px;
    justify-content: flex-start;
  }

  .category-link {
    font-size: 0.85rem;
    padding: 12px 0;
  }
}

/* Shiriti i sipërm me mesazh rrotullues (fade), stil i lehtë mbi header */
.announce-rotator {
  background: #f5f5f5;
  min-height: 42px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.announce-rotator-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #b9b9b9;
  text-transform: lowercase;
  text-align: center;
  animation: announceFade 3s ease both;
}

.announce-rotator-icon {
  font-size: 13px;
  opacity: 0.55;
}

@keyframes announceFade {
  0% { opacity: 0; transform: translateY(4px); }
  12% { opacity: 1; transform: none; }
  88% { opacity: 1; }
  100% { opacity: 0; }
}

/* Ndërruesi i gjuhës SQ | EN | DE */
.lang-switcher {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-right: 8px;
}

.lang-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: #b0b0b0;
  padding: 4px 6px;
  border-radius: 6px;
  transition: color 0.15s ease, background 0.15s ease;
}

.lang-btn:hover {
  color: #2e2e2e;
}

.lang-btn.active {
  color: #2e2e2e;
  background: #f0f0f0;
}

.mobile-lang-switcher {
  margin: 12px 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,iBAAiB;EACjB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,uBAAuB;EACvB,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,6BAA6B;IAC7B,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA,qBAAqB;EACrB;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA,sBAAsB;EACtB;IACE,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,eAAe;IACf,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA,0EAA0E;AAC1E;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,KAAK,UAAU,EAAE,0BAA0B,EAAE;EAC7C,MAAM,UAAU,EAAE,eAAe,EAAE;EACnC,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".main-header {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  background: white;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  border-bottom: 1px solid #f0f0f0;\n}\n\n/* Announcement Bar */\n.announcement-bar {\n  background: #2d2d2d;\n  color: white;\n  overflow: hidden;\n  position: relative;\n  height: 38px;\n}\n\n.announcement-content {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.announcement-text {\n  display: flex;\n  align-items: center;\n  gap: 50px;\n  white-space: nowrap;\n  animation: scroll-left 30s linear infinite;\n  padding: 10px 0;\n}\n\n.announcement-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  padding: 0 20px;\n}\n\n.announcement-item .icon {\n  font-size: 1rem;\n}\n\n@keyframes scroll-left {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n.announcement-bar:hover .announcement-text {\n  animation-play-state: paused;\n}\n\n/* Top Info Bar */\n.top-info-bar {\n  background: #f8f8f8;\n  padding: 8px 0;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.social-icons {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 40px;\n  display: flex;\n  gap: 15px;\n  justify-content: flex-start;\n}\n\n.social-icons a {\n  font-size: 1.2rem;\n  color: #666;\n  transition: color 0.3s ease;\n  text-decoration: none;\n}\n\n.social-icons a:hover {\n  color: inherit;\n}\n\n/* Top Bar */\n.top-bar {\n  background: none;\n  padding: 8px 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 50px;\n  font-size: 0.85rem;\n}\n\n.social-links {\n  display: flex;\n  gap: 15px;\n}\n\n.social-links a {\n  color: white;\n  text-decoration: none;\n  font-size: 0.9rem;\n  transition: opacity 0.3s ease;\n}\n\n.social-links a:hover {\n  opacity: 0.8;\n}\n\n.auth-buttons {\n  display: flex;\n  gap: 15px;\n}\n\n.btn-register,\n.btn-login {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  color: white;\n  padding: 6px 18px;\n  border-radius: 4px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.8rem;\n  letter-spacing: 0.5px;\n}\n\n.btn-register:hover,\n.btn-login:hover {\n  background: white;\n  color: inherit;\n  border-color: white;\n}\n\n/* Main Navigation */\n.main-nav {\n  background: white;\n  border-bottom: 1px solid #b5b5b5;\n}\n\n.nav-container {\n  max-width: 1728px;\n  margin: 0 auto;\n  padding: 16px 160px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 32px;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n  flex-shrink: 0;\n}\n\n.logo:hover {\n  transform: scale(1.05);\n}\n\n.logo-image {\n  height: 34px;\n  width: auto;\n  object-fit: contain;\n  display: block;\n}\n\n/* Search field */\n.search-field {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #f5f5f5;\n  border-radius: 8px;\n  padding: 16px;\n  height: 24px;\n  width: 372px;\n  flex-shrink: 0;\n}\n\n.search-field-icon {\n  width: 24px;\n  height: 24px;\n  opacity: 0.6;\n}\n\n.search-field-placeholder {\n  font-size: 14px;\n  font-weight: 500;\n  color: #656565;\n  opacity: 0.5;\n}\n\n.search-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.search-field-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 14px;\n  font-weight: 500;\n  color: #2e2e2e;\n  font-family: inherit;\n}\n\n.search-field-input::placeholder {\n  color: #656565;\n  opacity: 0.5;\n}\n\n.search-dropdown {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  background: #fff;\n  border: 1px solid #ececec;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  max-height: 340px;\n  overflow-y: auto;\n  z-index: 1000;\n}\n\n.search-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 10px;\n  cursor: pointer;\n}\n\n.search-row:hover {\n  background: #f5f5f5;\n}\n\n.search-row-img {\n  width: 36px;\n  height: 36px;\n  border-radius: 4px;\n  object-fit: cover;\n  background: #f0f0f0;\n  flex-shrink: 0;\n}\n\n.search-row-name {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #2e2e2e;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.search-row-price {\n  font-size: 13px;\n  font-weight: 600;\n  color: #2e2e2e;\n  flex-shrink: 0;\n}\n\n.search-empty {\n  padding: 12px;\n  font-size: 13px;\n  color: #656565;\n}\n\n/* Nav links */\n.main-nav-links {\n  display: flex;\n  align-items: center;\n  gap: 52px;\n  flex-shrink: 0;\n}\n\n.main-nav-link {\n  font-size: 16px;\n  font-weight: 500;\n  color: #000;\n  text-decoration: none;\n  white-space: nowrap;\n  opacity: 0.3;\n}\n\n.main-nav-link.active {\n  opacity: 1;\n}\n\n.main-nav-link.disabled {\n  cursor: default;\n}\n\n.logo-icon {\n  font-size: 2rem;\n}\n\n.logo-text {\n  font-size: 1.8rem;\n  font-weight: 900;\n  background: none;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: 1px;\n}\n\n.nav-menu {\n  display: flex;\n  gap: 35px;\n  align-items: center;\n}\n\n.nav-link {\n  color: #2d3748;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 0.95rem;\n  letter-spacing: 0.5px;\n  transition: color 0.3s ease;\n  position: relative;\n  padding: 5px 0;\n}\n\n.nav-link::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: none;\n  transition: width 0.3s ease;\n}\n\n.nav-link:hover::after,\n.nav-link.active::after {\n  width: 100%;\n}\n\n.nav-link:hover,\n.nav-link.active {\n  color: inherit;\n}\n\n.nav-actions {\n  display: flex;\n  gap: 24px;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n/* Burger Button - Hidden on Desktop */\n.burger-btn {\n  display: none;\n  background: transparent;\n  border: none;\n  font-size: 1.8rem;\n  cursor: pointer;\n  color: #333;\n  padding: 8px;\n  transition: all 0.3s ease;\n}\n\n.burger-btn:hover {\n  color: #667eea;\n}\n\n.icon-btn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-btn img {\n  width: 32px;\n  height: 32px;\n  display: block;\n}\n\n.icon-btn:hover {\n  transform: scale(1.1);\n}\n\n.search-btn, .user-btn {\n  font-size: 1.4rem;\n}\n\n.admin-btn {\n  background: none;\n  color: white;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(255, 140, 0, 0.3);\n}\n\n.admin-btn:hover {\n  color: white;\n  box-shadow: 0 4px 12px rgba(255, 140, 0, 0.5);\n  transform: translateY(-2px) rotate(90deg);\n}\n\n.cart-btn {\n  position: relative;\n}\n\n.cart-badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  background: #2d3748;\n  color: white;\n  font-size: 0.65rem;\n  font-weight: 700;\n  padding: 2px 5px;\n  border-radius: 10px;\n  min-width: 18px;\n  text-align: center;\n}\n\n/* Categories Bar */\n.categories-bar {\n  background: #fafafa;\n  border-top: 1px solid #e8e8e8;\n  border-bottom: 1px solid #e8e8e8;\n}\n\n.categories-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 40px;\n  display: flex;\n  gap: 40px;\n  justify-content: center;\n  align-items: center;\n  min-height: 50px;\n}\n\n.category-link {\n  color: #333;\n  text-decoration: none;\n  font-size: 0.95rem;\n  font-weight: 500;\n  padding: 15px 0;\n  position: relative;\n  transition: color 0.3s ease;\n  white-space: nowrap;\n}\n\n.category-link::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: #ed2b91;\n  transition: width 0.3s ease;\n}\n\n.category-link:hover {\n  color: #ed2b91;\n}\n\n.category-link:hover::after {\n  width: 100%;\n}\n\n.menu-toggle {\n  display: none;\n  background: transparent;\n  border: none;\n  font-size: 1.8rem;\n  cursor: pointer;\n  color: #2d3748;\n}\n\n@media (max-width: 1400px) {\n  .nav-container {\n    padding: 16px 48px;\n  }\n\n  .search-field {\n    width: 260px;\n  }\n\n  .main-nav-links {\n    gap: 28px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .nav-menu {\n    gap: 20px;\n  }\n\n  .nav-link {\n    font-size: 0.9rem;\n  }\n\n  .nav-container > .search-wrap,\n  .main-nav-links {\n    display: none;\n  }\n\n  .burger-btn {\n    display: block;\n  }\n\n  .nav-container {\n    padding: 16px 24px;\n  }\n}\n\n.mobile-nav-panel {\n  display: none;\n}\n\n@media (max-width: 1024px) {\n  .main-nav {\n    position: relative;\n  }\n\n  .mobile-nav-panel {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding: 16px 24px 24px;\n    border-top: 1px solid #f0f0f0;\n    background: white;\n  }\n\n  .mobile-search-field {\n    width: 100%;\n  }\n\n  .mobile-search-field .search-field {\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .mobile-nav-link {\n    font-size: 16px;\n    font-weight: 500;\n    color: #2e2e2e;\n  }\n}\n\n@media (max-width: 768px) {\n  .announcement-bar {\n    height: 36px;\n  }\n\n  .announcement-item {\n    font-size: 0.8rem;\n    padding: 0 15px;\n  }\n\n  .announcement-text {\n    gap: 30px;\n  }\n\n  .top-info-bar {\n    padding: 5px 0;\n  }\n\n  .social-icons {\n    padding: 0 20px;\n    gap: 12px;\n  }\n\n  .social-icons a {\n    font-size: 1rem;\n  }\n  \n  .nav-container {\n    padding: 0 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  /* Logo on the left */\n  .logo {\n    justify-self: start;\n  }\n  \n  .logo-image {\n    height: 50px;\n  }\n\n  /* Cart on the right */\n  .nav-actions {\n    gap: 15px;\n    justify-self: end;\n  }\n\n  .icon-btn {\n    font-size: 1.3rem;\n    padding: 5px;\n  }\n  \n  .categories-bar {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .categories-container {\n    padding: 0 20px;\n    gap: 25px;\n    justify-content: flex-start;\n  }\n\n  .category-link {\n    font-size: 0.85rem;\n    padding: 12px 0;\n  }\n}\n\n/* Shiriti i sipërm me mesazh rrotullues (fade), stil i lehtë mbi header */\n.announce-rotator {\n  background: #f5f5f5;\n  min-height: 42px;\n  padding: 10px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.announce-rotator-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #b9b9b9;\n  text-transform: lowercase;\n  text-align: center;\n  animation: announceFade 3s ease both;\n}\n\n.announce-rotator-icon {\n  font-size: 13px;\n  opacity: 0.55;\n}\n\n@keyframes announceFade {\n  0% { opacity: 0; transform: translateY(4px); }\n  12% { opacity: 1; transform: none; }\n  88% { opacity: 1; }\n  100% { opacity: 0; }\n}\n\n/* Ndërruesi i gjuhës SQ | EN | DE */\n.lang-switcher {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  margin-right: 8px;\n}\n\n.lang-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: #b0b0b0;\n  padding: 4px 6px;\n  border-radius: 6px;\n  transition: color 0.15s ease, background 0.15s ease;\n}\n\n.lang-btn:hover {\n  color: #2e2e2e;\n}\n\n.lang-btn.active {\n  color: #2e2e2e;\n  background: #f0f0f0;\n}\n\n.mobile-lang-switcher {\n  margin: 12px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
